export const initialState = {
  selectedStatus: null,
  fetchMoreIsBusy: false,
  currentPageIndex: 0,
  selectedOrderIndex: 0,
};

export const types = {
  SET_SELECTED_STATUS: 'SET_SELECTED_STATUS',
  SET_FETCH_MORE_IS_BUSY: 'SET_FETCH_MORE_IS_BUSY',
  SET_CURRENT_PAGE_INDEX: 'SET_CURRENT_PAGE_INDEX',
  SET_MULTI: 'SET_MULTI',
  SET_SELECTED_ORDER_INDEX: 'SET_SELECTED_ORDER_INDEX',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_SELECTED_STATUS:
      return { ...state, selectedStatus: payload };
    case types.SET_FETCH_MORE_IS_BUSY:
      return { ...state, fetchMoreIsBusy: payload };
    case types.SET_CURRENT_PAGE_INDEX:
      return { ...state, currentPageIndex: payload };
    case types.SET_SELECTED_ORDER_INDEX:
      return { ...state, selectedOrderIndex: payload };
    case types.SET_MULTI:
      return { ...state, ...payload };
    default:
      throw new Error();
  }
};
